import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "safe-area-top bg-brand-black sticky top-0 z-40" }
const _hoisted_2 = { class: "flex p-4 border-b border-brand-dark-gray border-opacity-80 justify-between" }
const _hoisted_3 = { class: "px-4 sticky backdrop-blur-md bottom-0 py-5 flex flex-col border-t border-brand-dark-gray border-opacity-80" }
const _hoisted_4 = { class: "flex m-auto space-x-2.5" }
const _hoisted_5 = { class: "my-auto pt-0.5" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "flex m-auto space-x-2.5" }
const _hoisted_9 = { class: "my-auto pt-0.5" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_buttons, { class: "justify-between flex" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { class: "justify-between flex opacity-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { class: "bg-brand-dark-gray rounded-md" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("svg", {
                        class: "",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M6 11.9961H18",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M12 18L6 12L12 6",
                          stroke: "white",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex px-4 flex-col space-y-8 my-auto py-8" }, [
            _createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
              _createElementVNode("div", { class: "flex text-white text-2xl font-medium" }, "Reporting users"),
              _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "The safety and comfort of our community is at the core of the Pineapple experience. We have a zero-tolerance policy towards violation of any of our core principles. Our reporting process is as follows: ")
            ]),
            _createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
              _createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Report user"),
              _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "The more details you provide the quicker we’ll be able to identify and investigate the user in question. None of the details you provide will be shared with the person you reported. l result in removal from our platform and a ban from attending our events. ")
            ]),
            _createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
              _createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Pineapple will investigate"),
              _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "A member of our Trust & Safety team will look into the matter to determine next steps and take action based on our Community Guidelines. Appropriate measures will be taken, which may include banning the user from our platform. This process usually takes up to 2 weeks and we will update you on the end result. ")
            ]),
            _createElementVNode("div", { class: "flex flex-col w-full space-y-1 px-2" }, [
              _createElementVNode("div", { class: "flex text-white text-xl font-medium" }, "Be truthful"),
              _createElementVNode("div", { class: "text-brand-light-gray text-base" }, "Every report is taken seriously and handled with care. Any user found creating fake reports will lead to a permanent ban from our platform. ")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reportUser && _ctx.reportUser(...args))),
              class: "mb-2 flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (!_ctx.reportBusy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Report user"))
                    : _createCommentVNode("", true),
                  (_ctx.reportBusy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-5 w-5 text-brand-black",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reportAndBlock && _ctx.reportAndBlock(...args))),
              class: "flex w-full bg-brand-dark-gray rounded-full px-8 h-14 font-medium text-xl text-white transition-all"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.reportAndBlockBusy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Report & block user"))
                    : _createCommentVNode("", true),
                  (_ctx.reportAndBlockBusy)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("svg", {
                          class: "animate-spin h-5 w-5 text-white",
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "safe-area-bottom" }, null, -1))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}